// extracted by mini-css-extract-plugin
module.exports = {"calc":"calc__2j_yd","selected":"selected__jTj4Y","del":"del__2dE0E"};